import axios, { AxiosPromise } from 'axios'
import { MChatPerguntaRespostaInput, MChatRiscoEnum } from 'graphql/types.generated'

export interface ImpressaoAcompanhamentoMChatInput {
  atendProfId: ID
  cidadaoId: ID
  resultado?: number
  risco?: MChatRiscoEnum
  aplicacao?: ReadonlyArray<MChatPerguntaRespostaInput>
  totalPerguntasRespondidas?: number
  totalPerguntasFalhou?: number
  totalPerguntasPassou?: number
  resultadoSeguimento?: MChatRiscoEnum
}

export class ImpressaoMChat {
  imprimirMChat(input: ImpressaoAcompanhamentoMChatInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirMChat', input, { responseType: 'blob' })
  }
}
